import { isolateDirection } from "@frontend-shared/lib";
import type { IChatListObject } from "@frontend-shared/types";
import { useTranslation } from "react-i18next";

import { ConfirmationDialog } from "@/components/ConfirmationDialog";

interface IDeleteChatDialogProps {
  // NOTE: NSAI-6473 — only the title is read, so the dialog takes the fields it
  // uses rather than a whole sidebar row. The chat page opens the same dialog
  // from its header, where the chat comes back from `useGetChatByUuid` as an
  // `IChat` and has no sidebar-only fields to give.
  chat: Pick<IChatListObject, "uuid" | "title">;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onDelete: () => void;
}

export const DeleteChatDialog = ({
  chat,
  isOpen,
  onOpenChange,
  onDelete,
}: IDeleteChatDialogProps) => {
  const { t } = useTranslation("sidebar");

  const handleDeleteClick = () => {
    onDelete();
    onOpenChange(false);
  };

  return (
    <ConfirmationDialog
      open={isOpen}
      onOpenChange={onOpenChange}
      content={{
        title: t("chat_list.delete_chat.title", {
          title: isolateDirection(chat.title),
        }),
        description: t("chat_list.delete_chat.description"),
        cancelText: t("chat_list.delete_chat.cancel"),
        confirmText: t("chat_list.delete_chat.delete"),
      }}
      actions={{
        onConfirm: handleDeleteClick,
      }}
      testIdPrefix="delete-chat"
    />
  );
};
